import i18n from 'i18n';

export const guidelineTypeOptions = [
  { value: 'BLOG_POST', label: i18n.t('Blog Post') },
  { value: 'CATEGORY', label: i18n.t('Category') },
  { value: 'PRODUCT', label: i18n.t('Product') },
];

export const guidelineDeliveryTypeOptions = [
  { value: 'PRODUCTION', label: i18n.t('Production') },
  { value: 'PRODUCTION_AND_UNIFICATION', label: i18n.t('Production and Unification') },
  { value: 'REVIEW', label: i18n.t('Review') },
  { value: 'REVIEW_AND_DIRECTIONS', label: i18n.t('Review and Directions') },
];

export const guidelineDeliveryTypeOptionsKanban = [
  { value: 'PRODUCTION', label: i18n.t('Production') },
  { value: 'PRODUCTION_AND_UNIFICATION', label: i18n.t('Unification') },
  { value: 'REVIEW', label: i18n.t('Review') },
  { value: 'REVIEW_AND_DIRECTIONS', label: i18n.t('Directions') },
];

export const languageOptions = [
  { value: 'pt-BR', label: i18n.t('Portuguese (BR)') },
  { value: 'en-US', label: i18n.t('English (US)') },
  { value: 'es-AR', label: i18n.t('Spanish (AR)') },
  { value: 'fr-FR', label: i18n.t('French (FR)') },
  { value: 'it-IT', label: i18n.t('Italian (IT)') },
  { value: 'pt-PT', label: i18n.t('Portuguese (PT)') },
  { value: 'es-CL', label: i18n.t('Spanish (CL)') },
  { value: 'es-CO', label: i18n.t('Spanish (CO)') },
  { value: 'es-MX', label: i18n.t('Spanish (MX)') },
  { value: 'es-ES', label: i18n.t('Spanish (ES)') },
  { value: 'en-GB', label: i18n.t('English (GB)') },
  { value: 'nl-NL', label: i18n.t('Dutch (NL)') },
];

export const betaLanguageOptions = [
  { value: 'pt-BR', label: i18n.t('Portuguese (BR)') },
  { value: 'en-US', label: i18n.t('English (US)') },
  { value: 'es-AR', label: i18n.t('Spanish (AR)') },
];
